import React from 'react'
import { connect } from 'react-redux'
import {Layout} from '@components/layout';
import { Circle } from '@am0nshi/react-preloaders'


function PreloaderContainer(props) {
    return props.show ? <Circle customLoading={props.show} time={0}/> : null;
    // return props.show ? (<Circle customLoading={props.show}/>) : null;
}

const mapStateToProps = (state, props) => ({
    show: state.layout.preloader.show
});

const actions = {
    openPreloader: Layout.actions.openPreloader,
    closePreloader: Layout.actions.closePreloader,
};

export default connect(mapStateToProps, actions)(PreloaderContainer)
